export enum AsyncReportStatus {
  none = 'none',
  new = 'new',
  processing = 'processing',
  completed = 'completed',
  error = 'error',
}

export enum AsyncReportType {
  Dashboard = 'Dashboard',
  Scan = 'Scan',
  Portfolio = 'Portfolio',
  Organization = 'Organization',
  MonitoringHistory = 'MonitoringHistory',
  UserList = 'UserList',
  AutoVpat = 'AutoVpat',
  CustomReport = 'CustomReport',
}

export enum $asyncReportClient {
  _id = '_id',
  type = 'type',
  status = 'status',
  requestedAt = 'requestedAt',
  requesterId = 'requesterId',
  generatedAt = 'generatedAt',
  reportUrl = 'reportUrl',
  extension = 'extension',
  digitalPropertyId = 'digitalPropertyId',
  tenantId = 'tenantId',
  workspaceId = 'workspaceId',
}

export enum $dashboardReportClient {
  toolName = 'toolName',
}

export enum $scanReportClient {
  scanId = 'scanId',
  scanTag = 'scanTag',
  scanUrl = 'scanUrl',
  auditTool = 'auditTool',
}

export enum $organizationReportClient {
  tenantId = 'tenantId',
  toolName = 'toolName',
}

export enum $userListReportClient {
  tenantId = 'tenantId',
  workspaceId = 'workspaceId',
  digitalPropertyId = 'digitalPropertyId',
}

export enum $autoVpatReportClient {
  evaluationIdsKey = 'evaluationIdsKey',
  vpatType = 'vpatType',
  templateVariant = 'templateVariant',
}

export enum $customReportExportClient {
  tenantId = 'tenantId',
  customReportExportKey = 'customReportExportKey',
}

export enum AutoVpatType {
  preview = 'preview',
  full = 'full',
}

export enum VpatTemplateVariant {
  International = 'International',
  // Standards combination was unrecognized - falls back to the International template to signal to the client that the match was not exact
  FallbackInternational = 'FallbackInternational',
  ModifiedInternational = 'ModifiedInternational',
  Wcag = 'Wcag',
  En301549 = 'En301549',
  Section508 = 'Section508',
}

export const MAX_MANUAL_EVALUATIONS_FOR_AUTO_VPAT = 10;
